import { useEffect, useState, useContext } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import WalletModal from "../modals/WalletModal";
import AuthDropdown from "../dropdowns/AuthDropdown";
import { ConnectionStatusContext } from "../../provider/ConnectionStatusProvider";

const navigation = [
  { name: "Home", href: "/#hero-section" },
  { name: "Services", href: "/#services" },
  { name: "Why Choose", href: "/#features" },
  // { name: "Developers", href: "#" },
];

const Header: React.FC = () => {
  const connectionStatus = useContext(ConnectionStatusContext);
  const [auth, setAuth] = useState<any>(false);
  const [account, setAccounts] = useState<any>(null);
  const [balance, setBalance] = useState<any>(null);
  // const [ordinals, setOrdinals] = useState(null)
  // const auth = false;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  function getValue(
    dictionary: { [key: string]: number },
    key: string
  ): number | string {
    if (key in dictionary) {
      return dictionary[key];
    } else {
      return "Key not found";
    }
  }

  useEffect(() => {
    if (connectionStatus) {
      setAuth(connectionStatus?.isConnected);
      if (connectionStatus?.type === "xverse") {
        setAccounts(
          connectionStatus?.accounts.find((v) => v.purpose === "ordinals")
        );
      } else {
        setAccounts(connectionStatus?.accounts);
      }

      // setAccounts(connectionStatus?.accounts);
    }
  }, [connectionStatus]);

  useEffect(() => {
    if (account && connectionStatus) {
      const balance =
        connectionStatus?.type === "xverse"
          ? getValue(connectionStatus?.balance, account.address)
          : connectionStatus?.balance;

      setBalance(balance);
    }
  }, [account, connectionStatus]);

  console.log("connectionStatus", connectionStatus);

  return (
    <header className="py-3 sticky top-0 z-20">
      <div className="container mx-auto px-4">
        {auth ? (
          <nav className="flex items-center justify-between gap-x-6 p-3 bg-gray-900 rounded-xl">
            <div
              className="flex lg:flex-1"
              data-aos="fade-down"
              data-aos-once="true"
            >
              <Link to="/" className="-m-1.5 p-1.5">
                <img
                  className="h-10 md:h-16 w-auto rounded-md"
                  src="/assets/images/logo.png"
                  alt="..."
                />
              </Link>
            </div>

            <div className="flex flex-1 items-center justify-end gap-x-5">
              <div
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-once="true"
                className={`items-center gap-1 border-2 border-primary rounded-lg py-1 px-2 ${
                  connectionStatus?.type === "xverse"
                    ? "flex"
                    : connectionStatus?.type === "xverse"
                    ? "flex"
                    : "hidden"
                }`}
              >
                <span className="font-semibold text-sm">
                  <span className="mr-1">BTC:</span>
                  {connectionStatus?.type === "xverse"
                    ? balance
                    : connectionStatus?.type === "unisat"
                    ? balance?.total
                    : null}
                </span>
                <img
                  className="h-6 w-6"
                  src="/assets/images/bitcoin.png"
                  alt="bitcoin icon"
                />
              </div>

              <span
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-once="true"
                className="truncate max-w-28 border-2 border-primary rounded-lg py-1 px-2"
              >
                {connectionStatus?.type === "xverse"
                  ? account?.address
                  : connectionStatus?.type === "unisat"
                  ? account
                  : null}
              </span>
              <div
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-once="true"
              >
                <AuthDropdown />
              </div>
            </div>
          </nav>
        ) : (
          <nav className="flex items-center justify-between gap-x-6 p-3 bg-gray-900 rounded-xl overflow-hidden">
            <div
              className="flex lg:flex-1"
              data-aos="fade-down"
              data-aos-once="true"
            >
              <Link to="/" className="-m-1.5 p-1.5">
                <img
                  className="h-16 w-auto rounded-md"
                  src="/assets/images/logo.png"
                  alt="..."
                />
              </Link>
            </div>
            <div
              className="hidden lg:flex lg:gap-x-12"
              data-aos="fade-down"
              data-aos-delay="100"
              data-aos-once="true"
            >
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="nav-link uppercase"
                >
                  {item.name}
                </a>
              ))}
            </div>
            <div
              className="flex flex-1 items-center justify-end gap-x-6"
              data-aos="fade-down"
              data-aos-delay="200"
              data-aos-once="true"
            >
              <div className="hidden lg:block">
                <WalletModal title="Connect" />
              </div>
            </div>
            <div className="flex lg:hidden">
              <button
                type="button"
                className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
                data-aos="fade-down"
                data-aos-delay="300"
                data-aos-once="true"
              >
                <span className="sr-only">Open main menu</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </nav>
        )}
      </div>
      <Dialog
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-20 w-full overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center gap-x-6">
            <Link to="/" className="block mr-auto">
              <img
                className="h-14 w-auto rounded-md"
                src="/assets/images/logo.png"
                alt="..."
              />
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-200"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:bg-primaryHover"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
              <div className="pt-0">
                <WalletModal title="Connect" />
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};

export default Header;
